import { NotificationT } from '@ruminati/types_v2/notification'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationsStore = defineStore('notifications', () => {
  const notifications = ref<Array<NotificationT> | undefined>()

  function setNotifications(newNotifications: Array<NotificationT>) {
    notifications.value = newNotifications
  }

  function updateNotification(notification: NotificationT) {
    if (!notifications.value) return
    const idx = notifications.value.findIndex((n) => n.id === notification.id)
    if (idx !== -1) {
      notifications.value.splice(idx, 1, notification)
    }
  }

  function reset() {
    notifications.value = undefined
  }

  return {
    notifications,
    setNotifications,
    updateNotification,
    reset,
  }
})
